import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

const SEARCH_TYPES = [
  { value: 'All',     label: 'All', ta: 'அனைத்தும்'     },
  { value: 'Books',   label: 'Books',  ta: 'புத்தகம்'   },
  { value: 'Authors', label: 'Authors', ta: 'எழுத்தாளர்' },
  // { value: 'Reviews', label: 'Reviews', ta: 'விமர்சனம்' },
];

export default function GlobalSearch() {
  const [searchType, setSearchType] = useState('All');
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const handleSearch = useCallback(() => {
    const q = searchText.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}&type=${searchType}`);
  }, [searchText, searchType, navigate]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="gs-wrap" role="search" aria-label="புத்தகம் / எழுத்தாளர் தேடல்">

      {/* Search type */}
      <label htmlFor="gs-type" className="visually-hidden">Search  Type</label>
      <select id="gs-type" className="gs-select"
              value={searchType}
              onChange={e => setSearchType(e.target.value)}
              title="Search type">
        {SEARCH_TYPES.map(({ value, label, en }) => (
          <option key={value} value={value} title={en}>{label}</option>
        ))}
      </select>

      {/* Divider */}
      <div className="gs-divider" aria-hidden="true" />

      {/* Text input */}
      <label htmlFor="gs-input" className="visually-hidden">தேடல்</label>
      <input id="gs-input" type="search"
             className="gs-input"
             placeholder="புத்தகம், எழுத்தாளர்..."
             value={searchText}
             onChange={e => setSearchText(e.target.value)}
             onKeyDown={handleKeyDown}
             autoComplete="off"
             aria-label="தேடல் உரை" />

      {/* Search button */}
      {/* white on #C4005A = 5.2:1 ✅ */}
      <button className="gs-btn" type="button"
              onClick={handleSearch}
              aria-label="தேடு"
              title="Search"
              disabled={!searchText.trim()}>
        <Search size={16} aria-hidden="true" />
      </button>

    </div>
  );
}